import React from "react";
import {Button, ConfigProvider} from "antd";
import {OrderStatusView} from "../../event/OrderStatusView/OrderStatusView.jsx";
import "./delivery-info-page.css";
import {
    DeliveryProviderDeliveryStatus,
    DeliveryProviderDeliveryStatusToText,
    DeliveryStatusToColor
} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import moment from "moment";
import {openWindow} from "../../http/WindowOpener.jsx";

export const DeliveryStatusHistorySection = ({deliveryInfo = {}, showHeader = true}) => {
    const statusHistory = deliveryInfo?.delivery?.statusHistory || [];

    if (!statusHistory || statusHistory.length === 0) {
        return null;
    }

    return (
        <ConfigProvider direction="rtl">
            <OrderStatusView
                className="delivery-info-status-history-container"
                title={showHeader ? <span>היסטוריית משלוח</span> : null}
                description={statusHistory.map((historyItem, index) => (
                    <div key={index} className="status-history-item">
                        <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                            <div className="delivery-status-message-container">
                                <span className="delivery-status-message-title">
                                    - {DeliveryProviderDeliveryStatusToText[historyItem?.status]} :{" "}
                                </span>
                                <span className="delivery-status-message-description">
                                    {moment(historyItem.createdAt).format("HH:mm")}
                                </span>
                                {historyItem?.status === DeliveryProviderDeliveryStatus.pickedUp && (
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            openWindow(
                                                deliveryInfo?.delivery?.businessSignature?.signatureUrl,
                                                "_blank",
                                                true
                                            )
                                        }>
                                        - צפייה בחתימה
                                    </Button>
                                )}
                                {historyItem?.status === DeliveryProviderDeliveryStatus.supplied && (
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            openWindow(
                                                deliveryInfo?.delivery?.clientSignature?.signatureUrl,
                                                "_blank",
                                                true
                                            )
                                        }>
                                        - צפייה בחתימה
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            />
        </ConfigProvider>
    );
};
